export default __webpack_public_path__ + "static/loop-939f5e36cd54fba58cd6c828e38e5052.png";